import { useMyOrders } from "api/Client/product";
import InputSearch, {
  SelectInput,
} from "components/ClientLayoutPages/ClientInputField/InputsFilter";
import Container from "components/ClientLayoutPages/Container/Container";
import MyOrderModal from "components/Modal/Client/MyOrderModal/MyOrderModal";
import SkeletonMyOrder from "components/SkeletonList/SkeletonMyOrder";
import useParam from "Hooks/useParam";
import { useEffect, useState } from "react";
import { FaCheck, FaTimes } from "react-icons/fa"; // أيقونات من FontAwesome
import { FaMoneyBillTransfer } from "react-icons/fa6";
import { GiSandsOfTime, GiTakeMyMoney } from "react-icons/gi";
import { MdNumbers } from "react-icons/md";
import { SlCalender } from "react-icons/sl";

export default function MyOrders() {
  const orderId = useParam("orderId");
  const [openMyOrderModal, setOpenMyOrderModal] = useState(false);
  const [currentId, setCurrentId] = useState(orderId || null);

  const [pageNumber, setPageNumber] = useState(1);
  const [limit, setLimit] = useState(9);

  const [searchValue, setSearchValue] = useState("");
  const [orderState, setOrderSate] = useState("");

  const {
    data: myOrders,
    isFetching: myOrdersIsLoading,
    isSuccess: myOrdersIsSuccess,
  } = useMyOrders(limit, pageNumber, searchValue, orderState);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pageNumber]);

  useEffect(() => {
    if (orderId) {
      setOpenMyOrderModal(true);
    }
  }, [orderId]);

  return (
    <Container title={`سجل السحب`}>
      <div className="grid grid-cols-2 border border-mainLight bg-mainLight/20 p-4 pt-2 rounded-lg max-w-md mb-8 mt-4 gap-4 mx-auto shadow-md">
        <InputSearch
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          setPageNumber={setPageNumber}
        />
        <SelectInput
          value={orderState}
          setValue={setOrderSate}
          setPageNumber={setPageNumber}
          options={[
            { value: "completed", label: "مكتمل" },
            { value: "canceled", label: "مرفوضة" },
            { value: "pending", label: "انتظار" },
          ]}
        />
      </div>

      {myOrdersIsLoading && <SkeletonMyOrder number={6} />}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {!myOrdersIsLoading &&
          myOrdersIsSuccess &&
          myOrders.data?.orders.length > 0 &&
          myOrders.data.orders.map((item) => (
            <div
              key={item.id}
              onClick={() => {
                setCurrentId(item.id);
                setOpenMyOrderModal(true);
              }}
              className="relative card-animation bg-mainLight/20 cursor-pointer hover:scale-105 transition-transform duration-300 grid gap-1 h-56 text-white p-4 rounded-2xl shadow-lg border border-mainLight hover:shadow-xl hover:bg-mainLight/40"
            >
              {/* <img
                src={logo}
                alt=""
                className="absolute z-10 w-40 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-20"
              /> */}

              <div className="flex justify-between items-center flex-row-reverse z-20">
                {" "}
                <h2
                  className="text-xl font-bold text-white"
                  style={{ direction: "ltr" }}
                >
                  {Number(Math.abs(item.total)).toLocaleString()}{" "}
                  <span className="text-sm">{item.currency} </span>
                </h2>
                {item.order_state === "pending" ? (
                  <div className={`text-white items-center flex gap-3`}>
                    <div className="text-xl p-1">
                      <GiSandsOfTime />
                    </div>
                    <span className="font-bold">{"انتظار"}</span>
                  </div>
                ) : item.order_state === "approved" ||
                  item.order_state === "completed" ? (
                  <div className={`text-green-500 items-center flex gap-3`}>
                    <div className="text-xl p-1">
                      <FaCheck />
                    </div>
                    <span className="font-bold">{"مكتملة"}</span>
                  </div>
                ) : item.order_state === "rejected" ||
                  item.order_state === "canceled" ? (
                  <div className={`text-red-500 items-center flex gap-3`}>
                    <div className="text-xl p-1">
                      <FaTimes />
                    </div>
                    <span className="font-bold">{"مرفوضة"}</span>
                  </div>
                ) : null}
              </div>
              <div className={`text-white items-center flex gap-3 z-20`}>
                <div className="text-xl p-1 text-white">
                  <FaMoneyBillTransfer />
                </div>
                <span className="font-bold">سحب مبلغ</span>
              </div>
              <div className={`text-white items-center flex gap-3 z-20`}>
                <div className="text-xl p-1 text-white">
                  <MdNumbers />
                </div>
                <span className="font-bold"> {item.id}</span>
              </div>
              <div className="text-white items-center text-sm flex gap-3 z-20">
                <div className="text-xl p-1 text-white">
                  <GiTakeMyMoney />
                </div>{" "}
                <span className="font-bold line-clamp-2 overflow-hidden text-ellipsis">
                  {item.service}
                </span>
              </div>

              <div className="text-white items-center flex gap-3 z-20">
                <div className="text-xl p-1 text-white">
                  <SlCalender />
                </div>{" "}
                <span style={{ direction: "ltr" }} className="font-bold">
                  {" "}
                  {item.created_at}{" "}
                </span>
              </div>
            </div>
          ))}
      </div>

      {/* Pagination */}
      <div className="flex flex-col items-center mt-16 w-full">
        <span className="text-sm text-white flex gap-1">
          <span className="font-semibold">
            {myOrders?.data?.pagination?.current_page || 0}
          </span>
          <span className="font-medium">من اصل</span>
          <span className="font-semibold">
            {myOrders?.data?.pagination?.last_page || 0}
          </span>{" "}
        </span>
        <div className="flex gap-4 mt-2">
          <button
            onClick={() => setPageNumber((prev) => prev - 1)}
            disabled={pageNumber === 1 || myOrdersIsLoading}
            className="btn btn-smart text-sm !p-1 w-20 "
          >
            السابق
          </button>
          <button
            onClick={() => setPageNumber((prev) => prev + 1)}
            disabled={
              myOrders?.data?.orders.length === 0 ||
              pageNumber >= myOrders?.data.pagination?.last_page ||
              myOrders?.data?.pagination?.total === 0 ||
              myOrdersIsLoading
            }
            className="btn btn-smart text-sm !p-1 w-20 "
          >
            التالي
          </button>
        </div>
      </div>

      {openMyOrderModal && (
        <MyOrderModal
          isOpen={openMyOrderModal}
          toggle={setOpenMyOrderModal}
          orderId={currentId}
          url={orderId}
        />
      )}
    </Container>
  );
}
